import Button from '@/components/basicComponents/button';
import NoResults from '@/components/table/noResults';
import { TableRowCell, TableRowWrapper, TextCell } from '@/components/table/styles';
import guid from '@/shared/utils/guid';
import styled from 'styled-components';
import { InvestorEntitiesRowStatus } from '../../../investorEntitiesRowStatus';
import { IGroupImportComparison, TypeWindow } from '../../../types';
import { columns } from '../constants';

interface TableBodyProps {
  tableData: IGroupImportComparison[];
  openGroupImportDetailPage: (type: TypeWindow, row: IGroupImportComparison) => void;
}

const TableBody = ({ tableData, openGroupImportDetailPage }: TableBodyProps) => {
  if (!tableData?.length) {
    return <NoResults />;
  }

  return (
    <>
      {tableData.map((row) => (
        <CustomTableRowWrapper key={guid()}>
          <TableRowCell width={columns[0].width}>
            <TextCell>{row.householdName}</TextCell>
          </TableRowCell>
          <TableRowCell width={columns[1].width}>
            <TextCell>{row.groupName}</TextCell>
          </TableRowCell>
          <TableRowCell width={columns[2].width}>
            <TextCell>{row.totalGrouped}</TextCell>
          </TableRowCell>
          <TableRowCell width={columns[3].width}>
            <TextCell>
              <TextCell>{row.newlyGrouped}</TextCell>
            </TextCell>
          </TableRowCell>
          <TableRowCell width={columns[4].width}>
            <TextCell>{row.ungrouped}</TextCell>
          </TableRowCell>
          <TableRowCell width={columns[5].width}>
            <TextCell>{row.primaryEntityName}</TextCell>
          </TableRowCell>
          <TableRowCell width={columns[6].width}>
            <TextCell>
              <InvestorEntitiesRowStatus status={row.status} />
            </TextCell>
          </TableRowCell>
          <TableRowCell width={columns[7].width}>
            <ButtonWrap id="infoWrap">
              <Button size="sm" onClick={() => openGroupImportDetailPage('groupImportDetail', row)}>
                View
              </Button>
            </ButtonWrap>
          </TableRowCell>
        </CustomTableRowWrapper>
      ))}
    </>
  );
};

export default TableBody;

const CustomTableRowWrapper = styled(TableRowWrapper)`
  justify-content: space-between;
`;

const ButtonWrap = styled.div`
  opacity: 0;
`;
